var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeneficiaryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74186 6.28302L4.74222 6.28281L10.6699 2.85412C10.6703 2.85391 10.6707 2.85371 10.671 2.8535C11.4979 2.38151 12.5077 2.38299 13.3218 2.853C13.3219 2.853 13.3219 2.85301 13.3219 2.85302L19.2586 6.28108C19.2591 6.28137 19.2595 6.28166 19.26 6.28195C20.0779 6.76325 20.5827 7.63037 20.5919 8.58236V15.42C20.5919 16.3724 20.0863 17.2468 19.2719 17.717L19.2718 17.717L13.3338 21.1459C13.3336 21.146 13.3333 21.1461 13.3331 21.1463C12.5062 21.6185 11.4962 21.6171 10.6819 21.147C10.6819 21.147 10.6819 21.147 10.6819 21.147L4.74519 17.7189C4.74468 17.7186 4.74416 17.7183 4.74365 17.718C3.92571 17.2366 3.42188 16.3602 3.42188 15.42V8.58C3.42188 7.62761 3.92746 6.75319 4.74186 6.28302ZM8.07712 14.8108L8.07681 14.8112C7.40783 15.8073 8.10439 17.16 9.32187 17.16H14.6819C15.8834 17.16 16.6005 15.8012 15.9259 14.8097C15.1393 13.6423 13.6521 12.9 12.0019 12.9C10.3512 12.9 8.8635 13.6428 8.07712 14.8108ZM14.8319 9.67C14.8319 8.10386 13.568 6.84 12.0019 6.84C10.4343 6.84 9.17188 8.11526 9.17188 9.67C9.17188 11.2361 10.4357 12.5 12.0019 12.5C13.568 12.5 14.8319 11.2361 14.8319 9.67Z",
    fill: "#0A0A0B",
    stroke: "#0A0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficiaryActive);
export default __webpack_public_path__ + "static/media/BeneficiaryActive.856d9a658c4950ee5a40d82c916070ca.svg";
export { ForwardRef as ReactComponent };